import { Box, Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ILooseObject } from '@/src/types/common.interface';
import lightTheme from '@/src/styles/themes/lightTheme';

interface ISchemaNodeProps {
  name: string;
  schema: ILooseObject;
  level?: number;
}
const SchemaNode = (props: ISchemaNodeProps) => {
  const { level = 0, name, schema } = props;
  const hasChildren = schema?.properties;

  return (
    <Accordion disableGutters elevation={0} sx={{ ml: level * 0.5 }}>
      <AccordionSummary
        expandIcon={hasChildren && <ExpandMoreIcon fontSize="small" />}
        sx={{ borderBottom: 1, borderColor: lightTheme.palette.grey[200] }}
      >
        <Typography fontSize={13} fontWeight={600}>
          {name}
        </Typography>
      </AccordionSummary>

      <AccordionDetails sx={{ pt: 0 }}>
        {schema.description && (
          <Typography fontSize={12} color="text.secondary">
            {schema.description}
          </Typography>
        )}

        {schema.example && (
          <Typography fontSize={11} sx={{ mt: 0.5, fontFamily: 'monospace' }}>
            Example: {schema.example}
          </Typography>
        )}

        {hasChildren &&
          Object.entries(schema.properties).map(([key, value]) => (
            <SchemaNode key={key} name={key} schema={value as ILooseObject} level={level + 1} />
          ))}
      </AccordionDetails>
    </Accordion>
  );
};

interface IRenderHelperText {
  schema: ILooseObject;
}
const RenderHelpText = (props: IRenderHelperText) => {
  const { schema } = props;
  return (
    <Box sx={{ width: 380, maxHeight: 420, overflowY: 'auto', p: 1 }}>
      <Typography fontSize={14} fontWeight={700} mb={0.5}>
        Input Context
      </Typography>

      <Typography fontSize={12} color="text.secondary" mb={1}>
        {schema.description}
      </Typography>

      {Object.entries(schema.properties).map(([key, value]) => (
        <SchemaNode key={key} name={key} schema={value as ILooseObject} />
      ))}
    </Box>
  );
};

export default RenderHelpText;
